module.exports = __webpack_public_path__ + "static/media/about-plan-2025.30ee07f9.png";